import { useState } from "react";
import useHttpHook from "../../../../Hooks/HttpHook";
import { DeleteAttendee } from "../../../../utils/ApiConstant";
import { dateFormatter, getImageUrl } from "../../../../utils/Helper";
import AttendeeForm from "./AttendeeForm";

const AttendeeList = (props) => {
  const [loading, sendRequest] = useHttpHook();
  const [edit, setEdit] = useState(false);

  const deleteAttendee = async () => {
    const data = {
      eventId: props.eventId,
      ticketId: props.ticketId,
      id: props.id,
    };
    const cartData = await sendRequest(DeleteAttendee, {
      method: "post",
      data,
    });
    if (cartData.status === 1) {
      props.getCartData();
    }
  };

  if (edit) {
    return (
      <tr className="event-attendee-row is-editing">
        <td colSpan="6">
          <AttendeeForm
            eventId={props.eventId}
            id={props.ticketId}
            attendee={props.attendee}
            getCartData={props.getCartData}
          />
        </td>
      </tr>
    );
  }

  return (
    <tr className="event-attendee-row">
      <td className="event-attendee-photo-cell">
        {props.attendee.photo?.length > 0 ? (
          <img
            className="event-attendee-photo"
            src={getImageUrl(props.attendee.photo[0].path)}
            alt=""
          />
        ) : (
          <span className="event-attendee-photo is-placeholder" aria-hidden="true">
            <i className="bi bi-person"></i>
          </span>
        )}
      </td>
      <td>{props.attendee.name}</td>
      <td>{props.attendee.email}</td>
      <td>{dateFormatter(props.attendee.dob)}</td>
      <td>{props.attendee.mobile}</td>
      <td className="event-attendee-actions-cell">
        <button
          type="button"
          className="event-attendee-action is-edit"
          aria-label="Edit attendee"
          disabled={loading}
          onClick={() => setEdit(true)}
        >
          <i className="bi bi-pencil-fill" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          className="event-attendee-action is-delete"
          aria-label="Delete attendee"
          disabled={loading}
          onClick={deleteAttendee}
        >
          <i className="bi bi-trash-fill" aria-hidden="true"></i>
        </button>
      </td>
    </tr>
  );
};

export default AttendeeList;
